import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { User, UserPreferences } from './User';
import { offlineUser } from './data/offlineUser';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OfflineUserService implements UserService {
  public user = new BehaviorSubject<User | null>(null);

  private localUser: User | null = null;
  constructor() {
    this.localUser = offlineUser;
    this.user.next(this.localUser);
  }

  savePreferredTagOrder(ids: string[]): Promise<void> {
    if (!this.localUser) {
      throw new Error('User not found');
    }
    this.localUser.tagIdsInPreferredOrder = ids;
    this.user.next(this.localUser);
    return Promise.resolve();
  }

  async update(user: User): Promise<void> {
    const newUser = { ...this.localUser, ...user };
    this.localUser = newUser;

    this.user.next(newUser);
  }
}
